module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightPage",
    attrs: {
      "id": "copyrightPage"
    }
  }, [_c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Published by"), _c('br'), _vm._v("Grub Street"), _c('br'), _vm._v("4 Rainham Close"), _c('br'), _vm._v("London"), _c('br'), _vm._v("SW11 6SS")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Copyright © Grub Street 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("Copyright text © Tony Blackman")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("Copyright introduction © HRH The Duke of Edinburgh")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("First published in hardback 2007")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("This edition first published 2009")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("British Library Cataloguing in Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("Blackman, Tony")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("Vulcan test pilot: my experiences in the cockpit of a Cold War icon")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("1. Blackman, Tony 2. Vulcan (Jet bomber)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("I. Title")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("623.7’463’0941")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ISBN-13: 9781906502300")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("eISBN: 978-1-908117-95-3")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the copyright owner.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Cover design by Lizzie B design")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Typeset by Pearl Graphics, Hemel Hempstead")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Printed and bound by MPG Ltd, Bodmin, Cornwall")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("Grub Street Publishing only uses")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("FSC (Forest Stewardship Council) paper for its books.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1d2e1f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VulcanTestPilot_copyright.vue
// module id = 63
// module chunks = 0